import { getCookie } from './cookies';

export function isNativeApp() {
  return getCookie('pp-native-app') != null;
}
